import React, { useMemo, useState } from "react";
import { Row, Col, Card, CardBody, Table, CardTitle, Container } from "reactstrap";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import Pagi2 from "common/utils/Pagi2";
import { CommonTableContainer } from "common/utils/ComonTableContainer";

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false);

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true);
    } else {
      setFixedHeader(false);
    }
  });

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-3 justify-content-between">
        <Col md={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={(e) => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div>
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonTableContainer columns={columns} data={data} status={true} />

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagi2
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  );
}

const ViewTask = ({ customer_task }) => {
  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "task_id",
        isInfoIcon: false,
        className: "task_id",
        Cell: (cellprops) => {
          return <div className="text-center"></div>;
        },
      },
      {
        Header: "Task Name",
        accessor: "task_name",
        isInfoIcon: false,
        className: "task_name",
      },
      {
        Header: "Related To",
        accessor: "task_related",
        isInfoIcon: false,
        className: "task_related",
      },
      {
        Header: "State Date",
        accessor: "task_start",
        isInfoIcon: false,
        className: "task_start",
      },
      {
        Header: "Due Date",
        accessor: "task_due",
        isInfoIcon: false,
        className: "task_due",
      },
      {
        Header: "Priority",
        accessor: "task_priority",
        isInfoIcon: false,
        className: "task_priority",
        Cell: (cellprops) => {
          const status = cellprops.row.original.task_priority;
          return status == "High" ? (
            <span
              className="badge bg-danger text-white"
              style={{ fontSize: "12px" }}
            >
              {cellprops.row.original.task_priority}
            </span>
          ) : status == "Medium" ? (
            <span
              className="badge bg-warning text-white"
              style={{ fontSize: "12px" }}
            >
              {cellprops.row.original.task_priority}
            </span>
          ) : status == "Low" ? (
            <span
              className="badge bg-primary text-white"
              style={{ fontSize: "12px" }}
            >
              {cellprops.row.original.task_priority}
            </span>
          ) : null;
        },
      },
      {
        Header: "Status",
        accessor: "task_status",
        isInfoIcon: false,
        className: "task_status",
      },

      {
        Header: "Action",
        accessor: "pro_action",
        isInfoIcon: false,
        className: "pro_action",
        Cell: (cellprops) => {
          return (
            <a className="btn btn-sm btn-outline-secondary me-1" title="View">
              <i className="fas fa-eye"></i>
            </a>
          );
        },
      },
    ],
    []
  );

  const data = [
    {
      task_id: 1,
      task_name: "Create Introducer Portals Customer Section.",
      task_related: "Sales",
      task_start: "08-12-2024",
      task_due: "18-12-2024",
      task_priority: "High",
      task_status: "In Progress",
    },
    {
      task_id: 2,
      task_name: "Create Introducer Portals Customer Section.",
      task_related: "Sales",
      task_start: "08-12-2024",
      task_due: "18-12-2024",
      task_priority: "Medium",
      task_status: "On Hold",
    },
    {
      task_id: 3,
      task_name: "Create Introducer Portals Customer Section.",
      task_related: "Sales",
      task_start: "08-12-2024",
      task_due: "18-12-2024",
      task_priority: "Low",
      task_status: "Not Started",
    },
    {
      task_id: 4,
      task_name: "Create Introducer Portals Customer Section.",
      task_related: "Sales",
      task_start: "08-12-2024",
      task_due: "18-12-2024",
      task_priority: "Medium",
      task_status: "Finished",
    },
    {
      task_id: 5,
      task_name: "Create Introducer Portals Customer Section.",
      task_related: "Sales",
      task_start: "08-12-2024",
      task_due: "18-12-2024",
      task_priority: "Low",
      task_status: "In Progress",
    },
  ];

  // return (
  //   <React.Fragment>
  //     <div>
  //       <div>
  //         <Row>
  //           <Col lg="12">
  //             <Card>
  //               <CardBody>
  //               <CardTitle className="mb-3 text-dark">General Tasks</CardTitle>

  //                 <div className="responsive-table">
  //                   <TableContainer
  //                     columns={columns}
  //                     data={data}
  //                   />
  //                 </div>
  //               </CardBody>
  //             </Card>
  //           </Col>
  //         </Row>
  //       </div>
  //     </div>
  //   </React.Fragment>
  // )

  return (
    <React.Fragment>
      <div
        className="page-content d-flex align-items-center justify-content-center"
        style={{ height: "100vh", width: "100%" }}
      >
        <Container fluid>
          <h1 className="fw-bold text-center">Coming Soon</h1>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewTask;
